var _path, _path2, _path3, _circle, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestDriveIconLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1474 6.99689L14.2027 7.14602L14.3571 7.18399L14.6834 7.26421V8.29607L14.3574 8.37613L14.2029 8.41408L14.1476 8.56325C14.1262 8.62123 14.1018 8.67958 14.0745 8.73792L14.0068 8.88302L14.0897 9.02003L14.2642 9.30858L13.5345 10.0383L13.2462 9.86383L13.1093 9.78104L12.9643 9.8485C12.9056 9.87584 12.8471 9.90029 12.7891 9.92177L12.64 9.97702L12.602 10.1315L12.5218 10.4577H11.4899L11.4099 10.1317L11.3719 9.97705L11.2225 9.92187C11.1645 9.90044 11.1062 9.87607 11.0479 9.84885L10.9028 9.78112L10.7657 9.86403L10.4774 10.0385L9.74771 9.30878L9.92222 9.02023L10.0051 8.88322L9.93737 8.73812C9.91014 8.67978 9.88573 8.62143 9.86425 8.56345L9.809 8.41432L9.65457 8.37635L9.32832 8.29613V7.26425L9.65412 7.1842L9.8081 7.14637L9.86357 6.99783C9.88542 6.93935 9.90995 6.88075 9.93717 6.82242L10.0049 6.67724L9.92194 6.54018L9.74739 6.25187L10.4772 5.52206L10.7655 5.69651L10.9024 5.7793L11.0474 5.71184C11.1061 5.6845 11.1646 5.66005 11.2226 5.63857L11.3717 5.58332L11.4097 5.42889L11.4899 5.10264H12.5217L12.6018 5.42879L12.6397 5.5833L12.7889 5.63857C12.8469 5.66005 12.9054 5.6845 12.9641 5.71184L13.1092 5.77933L13.246 5.69646L13.5343 5.52191L14.264 6.25156L14.0895 6.54011L14.0066 6.67712L14.0743 6.82222C14.1016 6.88056 14.126 6.93892 14.1474 6.99689Z",
    stroke: "white",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22534 19.1974H19.775",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99984 7.65598H6.05884C5.50655 7.65598 5.05884 8.10369 5.05884 8.65598V16.9099C5.05884 17.4622 5.50655 17.9099 6.05884 17.9099H18.0713C18.6236 17.9099 19.0713 17.4622 19.0713 16.9099V8.69246C19.0713 8.14018 18.6236 7.69246 18.0713 7.69246H15.0573",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0085,
    cy: 7.79231,
    r: 0.647821,
    stroke: "white",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 13.8205L7.6107 14.0982C8.00122 14.4887 8.6344 14.4887 9.02493 14.0982L10.3149 12.8083",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9534 12.5621L16.0872 14.6959",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0872 12.5621L13.9533 14.6959",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestDriveIconLight);
export default __webpack_public_path__ + "static/media/testDriveIconLight.506a335123c16de76e580b9b4890e848.svg";
export { ForwardRef as ReactComponent };